<div class="pageWrapper indirect_page">
  <div class="bredcrumbWrp">
    <ul>
        <li *ngIf="parentCategoryName && parentCategoryId !==1" class="active" (click)="getCategoryProduct(parentCategoryId, parentCategoryName)">
            {{parentCategoryName}}
        </li>
        <li>{{categoryName}}</li>
    </ul>
  </div>
  <div class="singleProduct">
    <div class="row">
      <!-- <span class="back-btn" (click)="back()">
        <lucide-icon [size]="18" name="ArrowLeft" class="menu_icon back_arrow"></lucide-icon>
        <span class="back-btn-label"> Back</span>
      </span> -->
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="product-image">
          <!-- <owl-carousel-o [options]="productShowCase"> -->
          <!-- <ng-template carouselSlide *ngFor="let productItem of product?.images"> -->
          <!-- </ng-template> -->
          <!-- <ng-template carouselSlide [width]="616">
                          <div class="image-container">
                              <img class="product-image" src="assets/images/drill-machine.webp" alt="">
                          </div>
                      </ng-template>
                      <ng-template carouselSlide [width]="616">
                          <div class="image-container">
                              <img class="product-image" src="assets/images/drill-machine.webp" alt="">
                          </div>
                      </ng-template> -->
          <!-- </owl-carousel-o> -->
  
          <div class="image-container">
            <img class="product-image" src="{{ product?.base_image?.original_image_url }}" alt="" />
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="product-detail">
          <h4 class="product-name">{{ product?.name }}</h4>
          <p class="product-description" [ngClass]="{ expanded: isExpanded }">
            {{ getDescription() }}
            <span *ngIf="showReadMoreLess()">
              <span *ngIf="!isExpanded" class="left-2">...</span>
              <small *ngIf="!isExpanded" class="primary-color" (click)="toggleReadMore()">Read more</small>
              <small *ngIf="isExpanded" class="primary-color" (click)="toggleReadMore()">Read less</small>
            </span>
          </p>
          <!-- <p>Add Quantity</p> -->
          <div class="quatity_box">
            <button [disabled]="quantity <= 0" class="number minus" (click)="minusQuantity()">
              <lucide-icon name="minus" [size]="18" class="lucid-icon"></lucide-icon>
            </button>
            <span class="quantity-input"><input type="number" name="" [(ngModel)]="quantity" /></span>
            <button class="number plus" (click)="addQuantity()">
              <lucide-icon name="plus" [size]="18" class="lucid-icon"></lucide-icon>
            </button>
          </div>
          <p *ngIf="quantity <= 0" class="errorTxt">Invalid quantity</p>
  
          <button mat-button class="get-quote-btn" (click)="addToCart(product)" [disabled]="quantity <= 0">Add to Cart</button>
  
          <strong class="desc_btn"> </strong>
        </div>
      </div>
    </div>
  
    <div class="row pdt-30" *ngIf="false">
      <div class="col-sm-12">
        <h2 class="mb-15">Product Detail</h2>
        <table class="additional-information">
          <ng-container *ngFor="let addData of additionalInformation">
            <tr *ngIf="addData.value != null && addData.code != 'ERP_ID' && addData.code != 'resolution'">
              <td class="title">{{ addData?.label }}</td>
              <td>{{ addData?.value }}</td>
            </tr>
          </ng-container>
        </table>
        <!-- <mat-tab-group [selectedIndex]="selectedTabIndex"> -->
        <!-- <mat-tab label="Product Details"> </mat-tab> -->
        <!-- <mat-tab label="Rating & Reviews">
                      <div class="review-head">
                          <span class="total-review">All Reviews (50)</span>
                          <span class="">
                              <button mat-button class="latest-review-btn">Latest</button>
                          </span>
                          <span class="review-info">
                              <button mat-button class="write-review-btn">Write a Review</button>
                          </span>
                      </div>
                      <div class="row">
                          <div class="col-sm-6 pdt-18">
                              <div class="review-card">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ellipsis"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
                                  <h2>Samantha D.</h2>
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                  <span>Posted on August 14, 2023</span>
                              </div>
                          </div>
                          <div class="col-sm-6 pdt-18">
                              <div class="review-card">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ellipsis"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
                                  <h2>Samantha D.</h2>
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                  <span>Posted on August 14, 2023</span>
                              </div>
                          </div>
                          <div class="col-sm-6 pdt-18">
                              <div class="review-card">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ellipsis"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
                                  <h2>Samantha D.</h2>
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                  <span>Posted on August 14, 2023</span>
                              </div>
                          </div>
                          <div class="col-sm-6 pdt-18">
                              <div class="review-card">
                                  <h2>Samantha D.</h2>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ellipsis"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                  <span>Posted on August 14, 2023</span>
                              </div>
                          </div>
                          <div class="col-sm-6 pdt-18">
                              <div class="review-card">
                                  <h2>Samantha D.</h2>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ellipsis"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                  <span>Posted on August 14, 2023</span>
                              </div>
                          </div>
                          <div class="col-sm-6 pdt-18">
                              <div class="review-card">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ellipsis"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
                                  <h2>Samantha D.</h2>
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                  <span>Posted on August 14, 2023</span>
                              </div>
                          </div>
                          <div class="col-sm-6 pdt-18">
                              <div class="review-card">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ellipsis"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
                                  <h2>Samantha D.</h2>
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                  <span>Posted on August 14, 2023</span>
                              </div>
                          </div>
                          <div class="col-sm-6 pdt-18">
                              <div class="review-card">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ellipsis"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
                                  <h2>Samantha D.</h2>
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                  <span>Posted on August 14, 2023</span>
                              </div>
                          </div>
                      </div>
                      <span class="load-more">
                          <button mat-button class="load-more-btn">Load more</button>
                      </span>
                  </mat-tab> -->
        <!-- <mat-tab label="FAQs">  </mat-tab> -->
        <!-- </mat-tab-group> -->
      </div>
    </div>

  </div>
  <div class="similarProduct">
    <h2>Find Similar Products</h2>
    <div class="produtsListSimilar">
      <ngx-slick-carousel class="carousel" 
          #slickModal="slick-carousel" 
          [config]="slickCapabilitesConfig"
      >
        <div ngxSlickItem class="product_box" *ngFor="let product of productList">
          <div class="productItem">
            <div class="product-card" (click)="redirectProductDetail(product?.id)">
              <span class="product-image">
                <img src="{{product?.base_image?.original_image_url}}" alt="" srcset="" />
              </span>
              <h5 class="product-name" matTooltip="{{ product?.name }}">{{ product?.name }}</h5> 
            </div>
            <!-- <button mat-button class="product-btn" (click)="addToCart(product)">Add to Cart</button> -->
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
</div>
